import moment from 'moment-timezone';


// ***** Timezones ***** //

function getTimezonesByCountry(countryCode) {
    const timezones = moment.tz.zonesForCountry(countryCode, true).sort((a, b) => b.offset - a.offset);

    return timezones.map((tz) => {
        return {
            name: tz.name,
            offset: moment.tz(moment(), tz.name).format('Z'),
            fullName:
                '(GMT' + moment.tz(moment(), tz.name).format('Z') + ') ' + tz.name.replace('_', ' '),
        };
    });
}

export const CA_TIMEZONES = getTimezonesByCountry('CA');
export const US_TIMEZONES = getTimezonesByCountry('US');


// ***** Date Formatting ***** //

const defaultLocale = moment.locale();

moment.locale('short-format', {
    relativeTime: {
        future: '%s',
        past: '%s',
        s: '<1m',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1mo',
        MM: '%dmo',
        y: '1y',
        yy: '%dy',
    }
});

// Prevents the custom locales above from being set as the default global locale
moment.locale(defaultLocale);

/**
 * @param {*} date Any moment object or string that can be converted to a moment object
 * @param {'short'|'default'} format Use 'short' for abbreviated output, otherwise default output
 */
export function getRelativeTime(date, format = 'default') {
    switch (format) {
        case 'short':
            return moment(date).locale('short-format').fromNow();
        default:
            return moment(date).fromNow();
    }
}
